import { render, staticRenderFns } from "./GenericThankYou.vue?vue&type=template&id=4c449d0c&"
import script from "./GenericThankYou.vue?vue&type=script&lang=js&"
export * from "./GenericThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports